import { useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router';
import getUrlPathnamePrefix from '../../lib/getUrlPathnamePrefix';



const useNavigationSource = (baseSource) => {
  const [ queryParams ] = useSearchParams();
  const { pathname } = useLocation();
  const navigationSource = queryParams.get('source') ?? null;


  return useMemo(() => {
    const urlPrefix = getUrlPathnamePrefix(pathname, baseSource);

    return { navigationSource, urlPrefix };
  }, [ navigationSource, pathname, baseSource ]);
};


export default useNavigationSource;
